import { TRAINING_SUB_STEPS } from "./setupSteps.js";

/**
 * Steps 3 and 4 have no server-side record — watching a video and installing a
 * desktop app aren't things the backend can observe — so their completion is
 * kept per-agent in localStorage. Steps 1 and 2 come from the API and are never
 * stored here.
 */
const TRAINING_KEY_PREFIX = "aam_setup_training_";
const DESKTOP_APP_KEY_PREFIX = "aam_setup_desktop_app_";

function readList(key: string): string[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((entry): entry is string => typeof entry === "string") : [];
  } catch {
    return [];
  }
}

function write(key: string, value: unknown) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage can be full or blocked (private mode). Progress just won't stick.
  }
}

export function readWatchedTrainingSteps(agentId: string | null | undefined): string[] {
  if (!agentId) return [];
  return readList(`${TRAINING_KEY_PREFIX}${agentId}`);
}

export function markTrainingStepWatched(agentId: string | null | undefined, stepId: string): string[] {
  if (!agentId) return [];
  const key = `${TRAINING_KEY_PREFIX}${agentId}`;
  const watched = readList(key);
  if (watched.includes(stepId)) return watched;
  const next = [...watched, stepId];
  write(key, next);
  return next;
}

export function isTrainingComplete(watched: string[]): boolean {
  return TRAINING_SUB_STEPS.every((step) => watched.includes(step.id));
}

export function readDesktopAppConfirmed(agentId: string | null | undefined): boolean {
  if (!agentId) return false;
  try {
    return window.localStorage.getItem(`${DESKTOP_APP_KEY_PREFIX}${agentId}`) === "true";
  } catch {
    return false;
  }
}

export function setDesktopAppConfirmed(agentId: string | null | undefined, confirmed: boolean) {
  if (!agentId) return;
  try {
    window.localStorage.setItem(`${DESKTOP_APP_KEY_PREFIX}${agentId}`, confirmed ? "true" : "false");
  } catch {
    // See write() above — non-critical.
  }
}
